import { isValidElement, type ReactElement, type ReactNode } from "react"

export type AsChildProps = {

  asChild?: boolean
}

export function asChildRender(
  asChild: boolean | undefined,
  children: ReactNode,
): { render: ReactElement } | { children: ReactNode } {
  return asChild && isValidElement(children)
    ? { render: children }
    : { children }
}
